import { KrCard } from '@/common/card/KrCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { useChatbotRegistration } from '../ai/ChatbotMgrContext';
import { useDashboardData } from './DashboardDataContext';

/**
 * The core dashboard card component that registers itself to the Chatbot.
 *
 * A card with a plugin fetches its own data. A card without one shows the data of the DashboardDataProvider it is in.
 */
export const DashboardCard = ({ title, description, module, plugin, reqParam, children, ...krCardProps }) => {
  const rsrc = useRsrc();
  const { data: contextData, dataFetchParams: contextDataFetchParams } = useDashboardData();
  const [cardData, setCardData] = useState();

  useEffect(() => {
    if (!plugin) return;
    rsrc.data(module, plugin, reqParam).then((res) => {
      setCardData(res);
    });
  }, [reqParam]);

  // The data and fetch params came either from a DashboardDataContext that is wrapped around this card, or we had to fetch it ourselves
  const data = plugin ? cardData : contextData;
  const dataFetchParams = plugin ? reqParam && { data: { module, plugin, reqParam } } : contextDataFetchParams;
  useChatbotRegistration(title, description, dataFetchParams);

  // The card shell mounts immediately so SpacerLayout can size the grid before the data arrives
  return (
    <KrCard title={title} {...krCardProps}>
      {data && children(data)}
    </KrCard>
  );
};
